import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import { Box, Text, Flex, Heading, List, ListItem, Link } from '@chakra-ui/react';
import TilesSection from '../../sections/TilesSection/TilesSection';
import './styles.css';
import StyledButton from '../../components/Button/Button';
import ImageWithBoxSection from '../../sections/ImageWithBoxSection/ImageWithBoxSection';
import { CheckIcon } from '@chakra-ui/icons';

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611732&ext=.webp',
    alt: 'Uśmiechnięta kobieta korzystająca z laptopa',
};

export default function FulfillmentPage() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <Box id="fulfillment">
                <HeroSection
                    title="Fulfillment i automatyzacja logistyki w sklepie internetowym"
                    subTitle="Zintegruj swój sklep internetowy z usługami fulfillmentu i przyspiesz realizację zamówień. Automatyzuj procesy, redukuj koszty i zapewnij klientom błyskawiczną dostawę"
                    image={image}
                    buttons={[
                        {
                            title: 'Włącz fulfillment w panelu',
                            href: 'https://pomoc.idosell.com/gospodarka-magazynowa/test12/fulfillment',
                            variant: 'default',
                        },
                    ]}
                />
                <div className="homepage containerIdosellPages">
                    <Box
                        margin={{ base: '0 15px', md: 0 }}
                        paddingBottom={{ base: '5px', lg: '50px' }}
                        id="tiles-fulfillment"
                    >
                        <TilesSection
                            title={'Nie trać czasu na pakowanie i wysyłkę - zleć to ekspertom'}
                            subtitle={
                                'IdoSell integruje się z wiodącymi usługami fulfillmentu, dzięki czemu zamówienia trafiają do klientów błyskawicznie, a Ty możesz skupić się na sprzedaży'
                            }
                            tiles={[
                                {
                                    title: 'Szybsza wysyłka',
                                    content:
                                        'Zamówienia realizowane są błyskawicznie, nawet tego samego dnia. Szybka dostawa to większa szansa na powrót kupujących do Twojego sklepu',
                                },
                                {
                                    title: 'Niższe koszty magazynowania',
                                    content:
                                        'Płacisz tylko za wykorzystaną przestrzeń, bez konieczności wynajmowania własnego magazynu. Unikasz dodatkowych kosztów związanych z personelem i zarządzaniem za pasami',
                                },
                                {
                                    title: 'Bezobsługowa logistyka',
                                    content:
                                        'Nie musisz samodzielnie pakować i wysyłać zamówień - fulfillment robi to za Ciebie. Możesz skupić się na sprzedaży i rozwoju swojego biznesu zamiast na logistyce',
                                },
                                {
                                    title: 'Skalowalność i elastyczność',
                                    content:
                                        'Fulfillment rośnie razem z Twoim sklepem, obsługując zarówno małe, jak i duże zamówienia. Nie martw się sezonowymi skokami sprzedaży - operator fulfillmentu dostosuje się do Twoich potrzeb',
                                },
                                {
                                    title: 'Profesjonalna obsługa zwrotów',
                                    content:
                                        'Zwroty i reklamacje są obsługiwane sprawnie, bez angażowania Twojego zespołu. To oznacza mniej pracy dla Ciebie i lepsze doświadczenie zakupowe dla klientów',
                                },
                                {
                                    title: 'Dostęp do nowoczesnej infrastruktury',
                                    content:
                                        'Operatorzy fulfillmentu korzystają z zaawansowanych technologii magazynowych, które minimalizują błędy. Dzięki temu masz pewność, że Twoje zamówienia są realizowane dokładnie i terminowo',
                                },
                            ]}
                        />
                    </Box>
                    <Box paddingBottom={{ base: '0', md: '63px' }}>
                        <Box margin={'0 auto 50px'} display={{ base: 'none', md: 'block' }}>
                            <Heading
                                as="h2"
                                fontWeight={600}
                                fontSize={{ base: '25px', lg: '34px' }}
                                lineHeight={{ base: '37px', lg: '48px' }}
                                textAlign={'center'}
                                marginBottom={{ base: '5px', lg: '20px' }}
                            >
                                {'Ty sprzedajesz, oni wysyłają'}
                            </Heading>
                            <Text
                                fontSize={{ base: '16px', lg: '18px' }}
                                marginBottom={{ base: '35px', lg: '50px' }}
                                textAlign={'center'}
                            >
                                Fulfillment to outsourcing logistyki Twojego e-sklepu. Zamiast
                                zajmować się magazynowaniem, pakowaniem i wysyłką, możesz przekazać
                                te zadania specjalistycznej firmie.
                            </Text>
                        </Box>
                        <Box display={{ base: 'block', lg: 'none' }}>
                            <Box
                                margin={'0 -15px'}
                                width={'100vw'}
                                position={'relative'}
                                maxHeight={'300px'}
                                overflow={'hidden'}
                            >
                                <img
                                    src="https://www.idosell.com/panel/file-gate.php?id=611751&ext=.webp"
                                    alt="Kobieta pracująca w magazynie"
                                    loading="lazy"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                                <Text
                                    fontSize={'30px'}
                                    lineHeight={'37px'}
                                    color={'white'}
                                    fontWeight={'600'}
                                    position={'absolute'}
                                    left={'30px'}
                                    bottom={'30px'}
                                    right={'30px'}
                                >
                                    Jak działa fulfillment?
                                </Text>
                            </Box>
                            <Box
                                position={'relative'}
                                padding={'44px 20px'}
                                _before={{
                                    content: '""',
                                    position: 'absolute',
                                    height: '100%',
                                    top: 0,
                                    width: '100vw',
                                    marginLeft: '50%',
                                    left: '-50vw',
                                    zIndex: -2,
                                    backgroundColor: '#1AAC7A',
                                }}
                            >
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color="#fff"
                                >
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            1.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Wysyłasz swoje towary do magazynu operatora
                                                fulfillmentu
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            2.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Nowe zamówienia są automatycznie przekazywane jest
                                                do centrum logistycznego, które otrzymuje
                                                powiadomienie o nowej paczce
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            3.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Operator pakuje paczkę i wysyła ją do klienta w
                                                imieniu Twojego sklepu
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            4.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Jeśli klient chce zwrócić produkt, operator odbiera
                                                go i zarządza zwrotem
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Box mt="20px" display={{ md: 'flex' }}>
                                    <StyledButton href={'https://pomoc.idosell.com/gospodarka-magazynowa/test12/fulfillment'} style={'default'} target="_self">
                                        Włącz fulfillment w panelu
                                    </StyledButton>
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            display={{ base: 'none', lg: 'grid' }}
                            gap="30px"
                            gridTemplateColumns={'repeat(3, minmax(0px, 1fr))'}
                        >
                            <Box position={'relative'} overflow={'hidden'}>
                                <img
                                    src="https://www.idosell.com/panel/file-gate.php?id=611751&ext=.webp"
                                    alt="Kobieta pracująca w magazynie"
                                    loading="lazy"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'48px'}
                                    color={'white'}
                                    fontWeight={'600'}
                                    position={'absolute'}
                                    left={'30px'}
                                    bottom={'30px'}
                                    right={'30px'}
                                >
                                    Jak działa fulfillment?
                                </Text>
                            </Box>
                            <Box
                                padding={{ lg: '50px 40px', xl: '80px 50px' }}
                                backgroundColor={'#1AAC7A'}
                                gridColumn={'span 2'}
                            >
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color="#fff"
                                >
                                    <ListItem display={'flex'} alignItems={'baseline'}>
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            1.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Wysyłasz swoje towary do magazynu operatora
                                                fulfillmentu
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem
                                        display={'flex'}
                                        alignItems={'baseline'}
                                        mt="30px !important"
                                    >
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            2.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Nowe zamówienia są automatycznie przekazywane jest
                                                do centrum logistycznego, które otrzymuje
                                                powiadomienie o nowej paczce
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem
                                        display={'flex'}
                                        alignItems={'baseline'}
                                        mt="30px !important"
                                    >
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            3.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Operator pakuje paczkę i wysyła ją do klienta w
                                                imieniu Twojego sklepu
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem
                                        display={'flex'}
                                        alignItems={'baseline'}
                                        mt="30px !important"
                                    >
                                        <Text
                                            width="20px"
                                            mr="30px"
                                            fontWeight={600}
                                            fontSize={'21px'}
                                            color={'#171717'}
                                        >
                                            4.
                                        </Text>
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Jeśli klient chce zwrócić produkt, operator odbiera
                                                go i zarządza zwrotem
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Box mt="30px">
                                    <Link
                                        href={'https://pomoc.idosell.com/gospodarka-magazynowa/test12/fulfillment'}
                                        target="_self"
                                        color={'#171717'}
                                        fontWeight={600}
                                        fontSize={'21px'}
                                        textDecoration={'underline'}
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        Włącz fulfillment w panelu
                                    </Link>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        py={{ base: '44px', lg: '74px' }}
                        mb={{ base: '55px', lg: '100px' }}
                        position={'relative'}
                        _before={{
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: '#E3E3E3',
                        }}
                    >
                        <Box
                            margin={{ base: '0 auto 35px', lg: '0 auto 40px' }}
                            display={{ base: 'none', md: 'block' }}
                        >
                            <Heading
                                as="h2"
                                fontWeight={600}
                                fontSize={{ base: '25px', lg: '34px' }}
                                lineHeight={{ base: '37px', lg: '48px' }}
                                textAlign={'center'}
                                marginBottom={{ base: '5px', lg: '20px' }}
                            >
                                {'Dostępne integracje fulfillmentowe w IdoSell'}
                            </Heading>
                            <Text
                                fontSize={{ base: '16px', lg: '18px' }}
                                marginBottom={{ base: '35px', lg: '50px' }}
                                textAlign={'center'}
                                display={{ base: 'none', lg: 'block' }}
                            >
                                Dzięki gotowym integracjom proces wysyłki jest szybki, automatyczny
                                i bezproblemowy
                            </Text>
                        </Box>
                        <Box
                            display={'grid'}
                            gap="20px"
                            gridTemplateColumns={{
                                base: 'repeat(2, minmax(0px, 1fr))',
                                lg: 'repeat(4, minmax(0px, 1fr))',
                            }}
                        >
                            <Flex
                                background={'#fff'}
                                padding={{ base: '12px 15px 40px', lg: '20px 25px 25px' }}
                                flexDirection={'column'}
                            >
                                <Flex
                                    padding={'7px'}
                                    boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
                                    mb={{ base: '18px', lg: '44px' }}
                                    alignSelf={'start'}
                                >
                                    <img
                                        src="https://www.idosell.com/panel/file-gate.php?id=611777&ext=.webp"
                                        alt="InPost Fulfillment"
                                        loading="lazy"
                                        style={{
                                            display: 'block',
                                        }}
                                    />
                                </Flex>
                                <Text
                                    as="strong"
                                    fontWeight={600}
                                    mb="10px"
                                    fontSize={{ base: '14px', lg: '21px' }}
                                >
                                    InPost Fulfillment
                                </Text>
                                <Text
                                    fontSize={'12px'}
                                    lineHeight={{ base: '16px', lg: '19px' }}
                                    minH={{ base: '140px' }}
                                    pb="20px"
                                >
                                    Szybka i wygodna obsługa wysyłek
                                </Text>
                                <Flex mt="auto" alignItems={'center'}>
                                    <Link
                                        href={'https://www.idosell.com/pl/system-zarzadzania-magazynem-wms/obsluga-fulfillment/inpost-fulfillment/'}
                                        target="_self"
                                        fontSize={'13px'}
                                        textDecoration={'underline'}
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        Dowiedz się więcej
                                    </Link>
                                    <Box ml="auto" display={{ base: 'none', lg: 'block' }}>
                                        <svg
                                            width="10"
                                            height="11"
                                            viewBox="0 0 10 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_13489_1734)">
                                                <path
                                                    d="M0.835283 2.79912H6.2294L0 9.02852L1.67057 10.6992L7.9001 4.46969V9.86387H10V0.699219H0.835283V2.79912Z"
                                                    fill="#171717"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_13489_1734">
                                                    <rect
                                                        width="10"
                                                        height="10"
                                                        fill="white"
                                                        transform="translate(0 0.699219)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </Box>
                                </Flex>
                            </Flex>
                            <Flex
                                background={'#fff'}
                                padding={{ base: '12px 15px 40px', lg: '20px 25px 25px' }}
                                flexDirection={'column'}
                            >
                                <Flex
                                    padding={'7px'}
                                    boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
                                    mb={{ base: '18px', lg: '44px' }}
                                    alignSelf={'start'}
                                >
                                    <img
                                        src="https://www.idosell.com/panel/file-gate.php?id=611822&ext=.webp"
                                        alt="Omnipack"
                                        loading="lazy"
                                        style={{
                                            display: 'block',
                                        }}
                                    />
                                </Flex>
                                <Text
                                    as="strong"
                                    fontWeight={600}
                                    mb="10px"
                                    fontSize={{ base: '14px', lg: '21px' }}
                                >
                                    Omnipack
                                </Text>
                                <Text
                                    fontSize={'12px'}
                                    lineHeight={{ base: '16px', lg: '19px' }}
                                    minH={{ base: '140px' }}
                                    pb="20px"
                                >
                                    Kompleksowe usługi magazynowe dla e-commerce
                                </Text>
                                <Flex mt="auto" alignItems={'center'}>
                                    <Link
                                        href={'https://www.idosell.com/pl/mozliwosci-systemu-wms-w-sklepach-internetowych/fulfillment-integracja-z-omnipack/'}
                                        target="_self"
                                        fontSize={'13px'}
                                        textDecoration={'underline'}
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        Dowiedz się więcej
                                    </Link>
                                    <Box ml="auto" display={{ base: 'none', lg: 'block' }}>
                                        <svg
                                            width="10"
                                            height="11"
                                            viewBox="0 0 10 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_13489_1734)">
                                                <path
                                                    d="M0.835283 2.79912H6.2294L0 9.02852L1.67057 10.6992L7.9001 4.46969V9.86387H10V0.699219H0.835283V2.79912Z"
                                                    fill="#171717"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_13489_1734">
                                                    <rect
                                                        width="10"
                                                        height="10"
                                                        fill="white"
                                                        transform="translate(0 0.699219)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </Box>
                                </Flex>
                            </Flex>
                            <Flex
                                background={'#fff'}
                                padding={{ base: '12px 15px 40px', lg: '20px 25px 25px' }}
                                flexDirection={'column'}
                            >
                                <Flex
                                    padding={'7px'}
                                    boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
                                    mb={{ base: '18px', lg: '44px' }}
                                    alignSelf={'start'}
                                >
                                    <img
                                        src="https://www.idosell.com/panel/file-gate.php?id=611823&ext=.webp"
                                        alt="OEX Fulfilio"
                                        loading="lazy"
                                        style={{
                                            display: 'block',
                                        }}
                                    />
                                </Flex>
                                <Text
                                    as="strong"
                                    fontWeight={600}
                                    mb="10px"
                                    fontSize={{ base: '14px', lg: '21px' }}
                                >
                                    OEX Fulfilio
                                </Text>
                                <Text
                                    fontSize={'12px'}
                                    lineHeight={{ base: '16px', lg: '19px' }}
                                    minH={{ base: '140px' }}
                                    pb="20px"
                                >
                                    Logistyka dostosowana do potrzeb Twojego sklepu
                                </Text>
                                <Flex mt="auto" alignItems={'center'}>
                                    <Link
                                        href={'https://www.idosell.com/pl/system-zarzadzania-magazynem-wms/obsluga-fulfillment/integracja-z-e-fulfillment-oex-e-business/'}
                                        target="_self"
                                        fontSize={'13px'}
                                        textDecoration={'underline'}
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        Dowiedz się więcej
                                    </Link>
                                    <Box ml="auto" display={{ base: 'none', lg: 'block' }}>
                                        <svg
                                            width="10"
                                            height="11"
                                            viewBox="0 0 10 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_13489_1734)">
                                                <path
                                                    d="M0.835283 2.79912H6.2294L0 9.02852L1.67057 10.6992L7.9001 4.46969V9.86387H10V0.699219H0.835283V2.79912Z"
                                                    fill="#171717"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_13489_1734">
                                                    <rect
                                                        width="10"
                                                        height="10"
                                                        fill="white"
                                                        transform="translate(0 0.699219)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </Box>
                                </Flex>
                            </Flex>
                            <Flex
                                background={'#fff'}
                                padding={{ base: '12px 15px 40px', lg: '20px 25px 25px' }}
                                flexDirection={'column'}
                            >
                                <Flex
                                    padding={'7px'}
                                    boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
                                    mb={{ base: '18px', lg: '44px' }}
                                    alignSelf={'start'}
                                >
                                    <img
                                        src="https://www.idosell.com/panel/file-gate.php?id=611824&ext=.webp"
                                        alt="Frisbo"
                                        loading="lazy"
                                        style={{
                                            display: 'block',
                                        }}
                                    />
                                </Flex>
                                <Text
                                    as="strong"
                                    fontWeight={600}
                                    mb="10px"
                                    fontSize={{ base: '14px', lg: '21px' }}
                                >
                                    Frisbo
                                </Text>
                                <Text
                                    fontSize={'12px'}
                                    lineHeight={{ base: '16px', lg: '19px' }}
                                    minH={{ base: '140px' }}
                                    pb="20px"
                                >
                                    Fulfillment w całej Europie
                                </Text>
                                <Flex mt="auto" alignItems={'center'}>
                                    <Link
                                        href={'https://www.idosell.com/pl/mozliwosci-systemu-wms-w-sklepach-internetowych/fulfillment-czyli-kompleksowa-obsluga-procesow-magazynowych-przez-wyspecjalizowana-firme-zewnetrzna/fulfillment-integracja-frisbo/'}
                                        target="_self"
                                        fontSize={'13px'}
                                        textDecoration={'underline'}
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        Dowiedz się więcej
                                    </Link>
                                    <Box ml="auto" display={{ base: 'none', lg: 'block' }}>
                                        <svg
                                            width="10"
                                            height="11"
                                            viewBox="0 0 10 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_13489_1734)">
                                                <path
                                                    d="M0.835283 2.79912H6.2294L0 9.02852L1.67057 10.6992L7.9001 4.46969V9.86387H10V0.699219H0.835283V2.79912Z"
                                                    fill="#171717"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_13489_1734">
                                                    <rect
                                                        width="10"
                                                        height="10"
                                                        fill="white"
                                                        transform="translate(0 0.699219)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </Box>
                                </Flex>
                            </Flex>
                        </Box>
                    </Box>
                    <ContactSection pb={1} mb={14} />
                </div>
            </Box>
        </ThemeProvider>
    );
}
